import {
  Container,
  Flex,
  SecondaryButton,
  Text,
} from '@moonpig/launchpad-components'
import { IconSystemTwinkle } from '@moonpig/launchpad-assets'
import { system as s } from '@moonpig/launchpad-system'
import { css, styled } from '@moonpig/launchpad-utils'

export const StyledSuggestionsContainer = styled(Container)`
  ${s({
    pl: 0,
    pr: 4,
  })}
` as React.ComponentType<React.HTMLAttributes<HTMLDivElement>>

export const StyledSuggestionTitleFlex = styled(Flex)`
  ${s({
    mb: 3,
    gap: 2,
    color: 'colorTextBody',
  })}

  flex-direction: row;
  justify-content: start;
  align-items: center;
`

export const StyledSuggestionTitleText = styled(Text)`
  ${s({
    typography: 'typeBodyCaption',
    color: 'colorBlack70',
    mb: '0px',
    pr: 3,
  })}
`

export const StyledIconSystemInformation = styled(IconSystemTwinkle)`
  ${s({
    height: 'iconSmall',
    width: 'iconSmall',
    color: 'colorBlack70',
  })}
`

export const SuggestionsMessageStyledFlex = styled(Flex)`
  ${s({
    mb: 6,
    gap: 3,
  })}
  flex-direction: column;
`

const sharedButtonStyles = css`
  ${s({
    bgcolor: 'colorBackground01',
    p: 4,
    mt: 4,
    borderRadius: 'borderRadius02',
    border: 2,
    borderColor: 'colorBlack20',
    boxShadow: 0,
    color: 'colorTextHeadline',
    typography: 'typeBodyText',
    fontWeight: '400',
  })}
  text-align: left;
  width: fit-content;
  margin-right: 0;

  &:not(:disabled):hover {
    ${s({
      bgcolor: 'colorBackground02',
      borderColor: 'colorBorder02',
    })}
    box-shadow: none;
  }

  &:not(:disabled):focus,
  &:not(:disabled):active {
    box-shadow: none;
    ${s({
      borderColor: 'colorBorder02',
    })}
  }
`

export const SuggestionsIntroMessageStyledButton = styled(SecondaryButton)`
  ${sharedButtonStyles}
`

export const SuggestionsAgentMessageStyledButton = styled(SecondaryButton)`
  ${sharedButtonStyles}

  white-space: nowrap;
  flex-shrink: 0;
`
